import { createAsyncThunk } from '@reduxjs/toolkit';
import createApiFromState from 'api/createApiFromState';

const licenceList = createAsyncThunk(
  'licence/list',
  async (arg, { dispatch, getState }) => {
    const api = createApiFromState({ dispatch, getState });
    const response = await api.get('/api/licences');

    return response.data;
  },
);

export { licenceList };
